import { DetailsState } from "@/types/details";
import { RootState } from "@/redux/store";
import { createSlice } from "@reduxjs/toolkit";

const initialState: DetailsState = { isDetailsPaneOpen: false, isSearchView: false };

export const detailsSlice = createSlice({
  name: "details",
  initialState,
  reducers: {
    toggleIsDetailsPaneOpen(state: DetailsState) {
      state.isDetailsPaneOpen = !state.isDetailsPaneOpen;
    },
    toggleIsSearchView(state: DetailsState) {
      state.isSearchView = !state.isSearchView;
    },
  },
  extraReducers: (builder) => {
    // The pane describes the open conversation and holds the delete action, so it has nothing
    // left to show once that conversation is gone (below md it also covers the chat). Closing
    // here rather than in the component keeps it in the same state update as the cleared
    // selection — no frame of stale details. By action type, to avoid importing controlSlice.
    builder.addCase("chat/deleteConversation/fulfilled", (state: DetailsState) => {
      state.isDetailsPaneOpen = false;
      state.isSearchView = false;
    });
  },
});
export const { toggleIsDetailsPaneOpen, toggleIsSearchView } = detailsSlice.actions;
export const selectIsDetailsPaneOpen = (state: RootState) => state.details.isDetailsPaneOpen;
export const selectIsSearchView = (state: RootState) => state.details.isSearchView;
export default detailsSlice.reducer;